// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI, { TabPane } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
// 
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;
axios.interceptors.request.use(

  config => {
    if (localStorage.token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = `${localStorage.token}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });
//响应了拦截器（在响应之后对数据进行一些处理）
axios.interceptors.response.use(function (response) {
    if(response.data.code==800){
      Vue.prototype.$message({
        type: "error",
        message: "token已过期，请重新登录"
      });
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      location.reload()
      //$router.push('/');

    }else if(response.data.code==810){
      Vue.prototype.$message({
        type: "error",
        message: "token无效，请重新登录"
      });
      localStorage.removeItem("token")
      localStorage.removeItem("username")
      location.reload()
      //$router.push('/');
    }else if(response.data.code==900){
      console.log(router)
      router.replace({ path: "/404" })
    }
    return response;
  },
  function (error) {
// 对响应错误做点什么
    return Promise.reject(error);
  });
// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

// 路由全局前置守卫
const whiteList = ['/login']  // 白名单
// 路由拦截器
router.beforeEach((to, from, next) => {
    if (localStorage.getItem("token")&&localStorage.getItem("username")) {
        // 有token、usernam、mune访问login页面，就跳到首页
        if (to.path === '/login' || to.path === '/') {
          next('/scjx/Scjx')
        }else {
            next()
        }
    
      }else {
        if (whiteList.includes(to.path)) { // 白名单，免密登录
          next()
        } else { // 否则就跳动登录页面
          next('/login')
        }
      }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})


// WEBPACK FOOTER //
// ./src/main.js